import { ActionIcon, Group, ImageMantine, Space, Stack, Text } from 'ui';
import { IconChevronRight } from 'ui/Icons';

type BaseCardProps = {
  image: string;
  title: string;
  subtitle?: string;
  amount: string;
  subText?: string;
  date?: string;
  onClick?: () => void;
  isFailed?: boolean;
};

const IMAGE_WIDTH = 48;
const GROUP_GAP = 12;
const ICON_WIDTH = 32;
const FLEX_BASIS = IMAGE_WIDTH + GROUP_GAP + ICON_WIDTH;

const WalletEntryCard = ({
  image,
  title,
  subtitle,
  amount,
  subText,
  onClick,
  isFailed = false,
}: BaseCardProps) => {
  return (
    <Group
      onClick={onClick}
      gap="sm"
      justify="space-between"
      px={{ base: 0, md: 'md' }}
      py={'sm'}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      wrap="nowrap"
    >
      <ImageMantine w={48} radius={12} src={image} />

      <Stack gap={4} flex={`1 0 calc(100% - ${FLEX_BASIS}px)`} maw={`calc(100% - ${FLEX_BASIS}px)`}>
        <Group justify="space-between">
          <Text fz={14} fw={500} truncate="end" style={{ flex: 1 }}>
            {title}
          </Text>
          <Text fz={14} fw={600} c={isFailed ? 'cerise.6' : 'mint.7'}>
            {amount}
          </Text>
        </Group>
        <Group justify="space-between">
          <Text fz={10} c="gray" truncate="end" style={{ flex: 1 }} h={15}>
            {subtitle}
          </Text>
          <Text fz={10} c="gray">
            {subText}
          </Text>
        </Group>
      </Stack>
      {onClick ? (
        <ActionIcon h={16} size="sm" variant="transparent" c="gray.4">
          <IconChevronRight />
        </ActionIcon>
      ) : (
        <Space w={32} />
      )}
    </Group>
  );
};

export { WalletEntryCard };
